module.exports = __webpack_public_path__ + "static/logo-hyperledger-8f9c25478659deef622dfff81d3fd6c7.png";